import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { plcTermCodesList } from "../../../types/axios";

interface reportSliceReducer {
  plcTermCodesList: plcTermCodesList[];
}

const initialState: reportSliceReducer = {
  plcTermCodesList: [],
};

const ReportsSliceReducer = createSlice({
  name: "plcreports",
  initialState,
  reducers: {
    setPlcTermCodesList(state, action: PayloadAction<plcTermCodesList[]>) {
      state.plcTermCodesList = action.payload;
    },
  },
});

export const { setPlcTermCodesList } = ReportsSliceReducer.actions;

export default ReportsSliceReducer.reducer;
